<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header">
        <i class="icon-note"></i> Transaksi Detail
      </div>

      <b-card-body>
        <div>
          <b-form id="transactionDetailForm" validated novalidate>
            <div v-if="loading == true">
              <loading></loading>
            </div>

            <div v-if="loading == false">
              <b-row>
                <b-col sm="3">
                    <b-form-group label-for="bank_of_account" label="Bank">
                        <model-select
                        id="bank_of_account"
                        :options="listBank"
                        v-model="$v.transactionDetailForm.bank_of_account.$model"
                        :isError="$v.transactionDetailForm.bank_of_account.$invalid"
                        placeholder="-- Harap pilih salah satu --"
                        :isDisabled="true"
                        ></model-select>
                        <div
                        v-if="transactionDetailForm.bank_of_account === null"
                        class="invalid-feedback-custom"
                        >Bank harus di isi.</div>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="transaction_date" label="Tanggal Transaksi">
                    <v-date-picker
                      id="transaction_date"
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Transaksi', required: '', disabled: true}"
                      :state="!$v.transactionDetailForm.transaction_date.$invalid"
                      v-model="$v.transactionDetailForm.transaction_date.$model"
                      
                    ></v-date-picker>
                    <div
                      v-if="$v.transactionDetailForm.transaction_date.$invalid"
                      class="invalid-feedback-custom"
                    >Tanggal Transaksi harus di isi.</div>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                    <b-form-group label-for="mutation" label="Mutasi">
                        <b-form-input
                            id="mutation"
                            type="text"
                            v-model="$v.transactionDetailForm.mutation.$model"
                            :state="!$v.transactionDetailForm.mutation.$invalid"
                            readonly
                            required
                            placeholder="Mutasi"
                        ></b-form-input>
                        <b-form-invalid-feedback>Mutasi harus di isi.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col sm="3">
                    <b-form-group label-for="mutation_type" label="Jenis Mutasi">
                        <model-select
                        id="mutation_type"
                        :options="listMutationType"
                        v-model="$v.transactionDetailForm.mutation_type.$model"
                        :isError="$v.transactionDetailForm.mutation_type.$invalid"
                        :isDisabled="true"
                        placeholder="-- Harap pilih salah satu --"
                        ></model-select>
                        <div
                        v-if="transactionDetailForm.mutation_type === null"
                        class="invalid-feedback-custom"
                        >Bank harus di isi.</div>
                  </b-form-group>
                </b-col>
              </b-row>

               <b-row>
                <b-col sm="3">
                    <b-form-group label-for="total" label="Saldo">
                        <b-form-input
                            id="total"
                            type="text"
                            v-model="$v.transactionDetailForm.total.$model"
                            :state="!$v.transactionDetailForm.total.$invalid"
                            readonly
                            required
                            placeholder="Saldo"
                        ></b-form-input>
                        <b-form-invalid-feedback>Saldo harus di isi.</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col sm="9">
                    <b-form-group label-for="description" label="Deskripsi">
                        <b-form-textarea
                        id="description"
                        :rows="3"
                        :max-rows="6"
                        disabled
                        v-model="$v.transactionDetailForm.description.$model"
                        :state="!$v.transactionDetailForm.description.$invalid"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>Deskripsi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="12">
                  <hr/>
                </b-col>
              </b-row>

              <template v-if="transactionDetailForm.mutation_type === 'CR' && transactionDetailForm.status === '1'">
                
                <template v-for="r in fieldRow" >
                  <b-row :key="r">
                    <b-col lg="3" sm="12">
                      <b-form-group :label-for="'spkb_'+r.toLowerCase()" :label="'SPKB '+r">
                          <vue-autosuggest
                              v-model="paymentSpkb['spkb_'+r.toLowerCase()]"
                              @inputout="focusMe($event, r)"
                              :suggestions="filteredOptions[r]"
                              @input="onInputChange($event, r)"
                              @selected="onSelected($event, r)"
                              @focus="resetClear(r)"
                              :input-props="{ id: 'spkb_'+r.toLowerCase(), placeholder: 'Find SPKB', class: 'form-control'}"
                              :limit="20"
                          >
                              <template slot-scope="{ suggestion }">
                                  <span class="my-suggestion-item"> 
                                      {{ suggestion.item.text }}
                                  </span>
                              </template>
                          </vue-autosuggest>

                      </b-form-group>
                    </b-col>
                    <b-col lg="3" sm="12">
                      <b-form-group :label-for="'piutang_spkb_'+r.toLowerCase()" :label="(paymentSpkb['spkb_'+r.toLowerCase()] === null) ? 'TOTAL PIUTANG SPKB '+r:'TOTAL PIUTANG SPKB '+ paymentSpkb['spkb_'+r.toLowerCase()] ">
                          
                          <b-form-input
                              v-if="r==='A'"
                              :id="'piutang_spkb_'+r.toLowerCase()"
                              type="text"
                              v-model="transactionDetailForm['piutang_spkb_'+r.toLowerCase()]"
                              :state="!$v.transactionDetailForm['piutang_spkb_'+r.toLowerCase()].$invalid"
                              @change="checking($event, piutangSpkb['spkb_'+r.toLowerCase()], paymentSpkb['spkb_'+r.toLowerCase()], r.toLowerCase())"
                              required
                              placeholder="Jenis Transaksi"
                          ></b-form-input>

                          <b-form-input
                              v-else
                              :id="'piutang_spkb_'+r.toLowerCase()"
                              type="text"
                              v-model="transactionDetailForm['piutang_spkb_'+r.toLowerCase()]"
                              :state="!$v.transactionDetailForm['piutang_spkb_'+r.toLowerCase()].$invalid"
                              @change="checking($event, piutangSpkb['spkb_'+r.toLowerCase()], paymentSpkb['spkb_'+r.toLowerCase()], r.toLowerCase())"
                              placeholder="Jenis Transaksi"
                          ></b-form-input>
                        
                          <b-form-invalid-feedback>Pembayaran SPKB {{r}} harus di isi.</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col lg="6" sm="12">
                      <template v-if="paymentSpkb['spkb_'+r.toLowerCase()] !== null">
                        <table class="table b-table table-bordered">
                          <thead>
                            <tr>
                              <th>Last Payment</th>
                              <th>Sisa Yang Harus Di Bayarkan</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{formatPrice(lastPayment['spkb_'+r.toLowerCase()])}}</td>
                              <td>{{formatPrice(piutangSpkb['spkb_'+r.toLowerCase()])}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </template>
                    </b-col>
                  </b-row>
                </template>
                
                <!-- <b-row >
                  <b-col lg="3" sm="12">
                    <b-form-group label-for="spkb_a" label="SPKB A">
                        <vue-autosuggest
                            v-model="paymentSpkb.spkb_a"
                            @inputout="focusMe($event, 'A')"
                            :suggestions="filteredOptions.A"
                            @input="onInputChange($event, 'A')"
                            @selected="onSelected($event, 'A')"
                            @focus="resetClear('A')"
                            :input-props="{ id: 'spkb_a', placeholder: 'Find SPKB', class: 'form-control'}"
                            :limit="20"
                        >
                            <template slot-scope="{ suggestion }">
                                <span class="my-suggestion-item"> 
                                    {{ suggestion.item.text }}
                                </span>
                            </template>
                        </vue-autosuggest>

                    </b-form-group>
                  </b-col>
                  <b-col lg="3" sm="12">
                    <b-form-group label-for="piutang_spkb_a" :label="(paymentSpkb.spkb_a === null) ? 'TOTAL PIUTANG SPKB A':'TOTAL PIUTANG SPKB '+ paymentSpkb.spkb_a ">
                        <b-form-input
                            id="piutang_spkb_a"
                            type="text"
                            v-model="transactionDetailForm.piutang_spkb_a"
                            :state="!$v.transactionDetailForm.piutang_spkb_a.$invalid"
                            @change="checking($event, piutangSpkb.spkb_a, paymentSpkb.spkb_a, 'a')"
                            required
                            placeholder="Jenis Transaksi"
                        ></b-form-input>
                       
                        <b-form-invalid-feedback>Pembayaran SPKB A harus di isi.</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6" sm="12">
                    <template v-if="paymentSpkb.spkb_a !== null">
                      <table class="table b-table table-bordered">
                        <thead>
                          <tr>
                            <th>Last Payment</th>
                            <th>Sisa Yang Harus Di Bayarkan</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{formatPrice(lastPayment.spkb_a)}}</td>
                            <td>{{formatPrice(piutangSpkb.spkb_a)}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </b-col>
                </b-row>

                <b-row >
                  <b-col lg="3" sm="12">
                    <b-form-group label-for="spkb_b" label="SPKB B">
                        <vue-autosuggest
                            v-model="paymentSpkb.spkb_b"
                            @inputout="focusMe($event, 'B')"
                            :suggestions="filteredOptions.B"
                            @input="onInputChange($event, 'B')"
                            @selected="onSelected($event, 'B')"
                            @focus="resetClear('B')"
                            :input-props="{ id: 'spkb_b', placeholder: 'Find SPKB', class: 'form-control'}"
                            :limit="20"
                        >
                            <template slot-scope="{ suggestion }">
                                <span class="my-suggestion-item"> 
                                    {{ suggestion.item.text }}
                                </span>
                            </template>
                        </vue-autosuggest>

                    </b-form-group>
                  </b-col>
                  <b-col lg="3" sm="12">
                    <b-form-group label-for="piutang_spkb_b" :label="(paymentSpkb.spkb_b === null) ? 'TOTAL PIUTANG SPKB B':'TOTAL PIUTANG SPKB '+ paymentSpkb.spkb_b ">
                        <b-form-input
                            type="text"
                            v-model="transactionDetailForm.piutang_spkb_b"
                            :state="!$v.transactionDetailForm.piutang_spkb_b.$invalid"
                            @change="checking($event, piutangSpkb.spkb_b, paymentSpkb.spkb_b, 'b')"
                            placeholder="Jenis Transaksi"
                        ></b-form-input>
                        <b-form-invalid-feedback>Pembayaran SPKB B harus di isi</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6" sm="12">
                    <template v-if="paymentSpkb.spkb_b !== null">
                      <table class="table b-table table-bordered">
                        <thead>
                          <tr>
                            <th>Last Payment</th>
                            <th>Sisa Yang Harus Di Bayarkan</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{formatPrice(lastPayment.spkb_b)}}</td>
                            <td>{{formatPrice(piutangSpkb.spkb_b)}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </b-col>
                </b-row>

                <b-row >
                  <b-col lg="3" sm="12">
                    <b-form-group label-for="spkb_c" label="SPKB C">
                        <vue-autosuggest
                            v-model="paymentSpkb.spkb_c"
                            @inputout="focusMe($event, 'C')"
                            :suggestions="filteredOptions.C"
                            @input="onInputChange($event, 'C')"
                            @selected="onSelected($event, 'C')"
                            @focus="resetClear('C')"
                            :input-props="{ id: 'spkb_c', placeholder: 'Find SPKB', class: 'form-control'}"
                            :limit="20"
                        >
                            <template slot-scope="{ suggestion }">
                                <span class="my-suggestion-item"> 
                                    {{ suggestion.item.text }}
                                </span>
                            </template>
                        </vue-autosuggest>

                    </b-form-group>
                  </b-col>
                  <b-col lg="3" sm="12">
                    <b-form-group label-for="piutang_spkb_c" :label="(paymentSpkb.spkb_c === null) ? 'TOTAL PIUTANG SPKB C':'TOTAL PIUTANG SPKB '+ paymentSpkb.spkb_c ">
                        <b-form-input
                            type="text"
                            v-model="transactionDetailForm.piutang_spkb_c"
                            :state="!$v.transactionDetailForm.piutang_spkb_c.$invalid"
                            placeholder="Jenis Transaksi"
                            @change="checking($event, piutangSpkb.spkb_c, paymentSpkb.spkb_c, 'c')"
                        ></b-form-input>
                        <b-form-invalid-feedback>Pembayaran SPKB B harus di isi</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6" sm="12">
                    <template v-if="paymentSpkb.spkb_c !== null">
                      <table class="table b-table table-bordered">
                        <thead>
                          <tr>
                            <th>Last Payment</th>
                            <th>Sisa Yang Harus Di Bayarkan</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{formatPrice(lastPayment.spkb_c)}}</td>
                            <td>{{formatPrice(piutangSpkb.spkb_c)}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </b-col>
                </b-row>

                <b-row >
                  <b-col lg="3" sm="12">
                    <b-form-group label-for="spkb_d" label="SPKB D">
                        <vue-autosuggest
                            v-model="paymentSpkb.spkb_d"
                            @inputout="focusMe($event, 'D')"
                            :suggestions="filteredOptions.D"
                            @input="onInputChange($event, 'D')"
                            @selected="onSelected($event, 'D')"
                            @focus="resetClear('D')"
                            :input-props="{ id: 'spkb_d', placeholder: 'Find SPKB', class: 'form-control'}"
                            :limit="20"
                        >
                            <template slot-scope="{ suggestion }">
                                <span class="my-suggestion-item"> 
                                    {{ suggestion.item.text }}
                                </span>
                            </template>
                        </vue-autosuggest>

                    </b-form-group>
                  </b-col>
                  <b-col lg="3" sm="12">
                    <b-form-group label-for="piutang_spkb_d" :label="(paymentSpkb.spkb_d === null) ? 'TOTAL PIUTANG SPKB D':'TOTAL PIUTANG SPKB '+ paymentSpkb.spkb_d ">
                        <b-form-input
                            type="text"
                            v-model="transactionDetailForm.piutang_spkb_d"
                            :state="!$v.transactionDetailForm.piutang_spkb_d.$invalid"
                            placeholder="Jenis Transaksi"
                            @change="checking($event, piutangSpkb.spkb_d, paymentSpkb.spkb_d, 'd')"
                        ></b-form-input>
                        <b-form-invalid-feedback>Pembayaran SPKB B harus di isi</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6" sm="12">
                    <template v-if="paymentSpkb.spkb_d !== null">
                      <table class="table b-table table-bordered">
                        <thead>
                          <tr>
                            <th>Last Payment</th>
                            <th>Sisa Yang Harus Di Bayarkan</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{formatPrice(lastPayment.spkb_d)}}</td>
                            <td>{{formatPrice(piutangSpkb.spkb_d)}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </b-col>
                </b-row>

                <b-row >
                  <b-col lg="3" sm="12">
                    <b-form-group label-for="spkb_e" label="SPKB E">
                        <vue-autosuggest
                            v-model="paymentSpkb.spkb_e"
                            @inputout="focusMe($event, 'E')"
                            :suggestions="filteredOptions.E"
                            @input="onInputChange($event, 'E')"
                            @selected="onSelected($event, 'E')"
                            @focus="resetClear('E')"
                            :input-props="{ id: 'spkb_e', placeholder: 'Find SPKB', class: 'form-control'}"
                            :limit="20"
                        >
                            <template slot-scope="{ suggestion }">
                                <span class="my-suggestion-item"> 
                                    {{ suggestion.item.text }}
                                </span>
                            </template>
                        </vue-autosuggest>

                    </b-form-group>
                  </b-col>
                  <b-col lg="3" sm="12">
                    <b-form-group label-for="piutang_spkb_e" :label="(paymentSpkb.spkb_e === null) ? 'TOTAL PIUTANG SPKB E':'TOTAL PIUTANG SPKB '+ paymentSpkb.spkb_e ">
                        <b-form-input
                            type="text"
                            v-model="transactionDetailForm.piutang_spkb_e"
                            :state="!$v.transactionDetailForm.piutang_spkb_e.$invalid"
                            placeholder="Jenis Transaksi"
                            @change="checking($event, piutangSpkb.spkb_e, paymentSpkb.spkb_e, 'e')"
                        ></b-form-input>
                        <b-form-invalid-feedback>Pembayaran SPKB B harus di isi</b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col lg="6" sm="12">
                    <template v-if="paymentSpkb.spkb_e !== null">
                      <table class="table b-table table-bordered">
                        <thead>
                          <tr>
                            <th>Last Payment</th>
                            <th>Sisa Yang Harus Di Bayarkan</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{formatPrice(lastPayment.spkb_e)}}</td>
                            <td>{{formatPrice(piutangSpkb.spkb_e)}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </b-col>
                </b-row> -->

              </template>

              <template v-if="transactionDetailForm.mutation_type === 'CR' && transactionDetailForm.status === '2'">
                  <template>
                      <p>History SPKB Di Transaksi ini</p>
                      <table class="table b-table table-bordered">
                        <thead>
                          <tr>
                            <th>SPKB</th>
                            <th>Tagihan</th>
                            <th>Dibayar</th>
                            <th>Sisa</th>
                          </tr>
                        </thead>
                        <tbody v-for="item in listHistory" :key="item.id">
                          <tr>
                            <td>{{item.spkb_number}}</td>
                            <td>{{formatPrice(item.amount)}}</td>
                            <td>{{formatPrice(item.paid)}}</td>
                            <td>{{formatPrice(item.outstanding)}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
              </template>

              <template v-if="transactionDetailForm.mutation_type === 'DB'">
                <b-row>
                  <b-col sm="3">
                      <b-form-group label-for="category" label="Kategori">
                          <model-select
                          id="category"
                          :options="listCategory"
                          v-model="$v.transactionDetailForm.category.$model"
                          :isError="$v.transactionDetailForm.category.$invalid"
                          placeholder="-- Harap pilih salah satu --"
                          ></model-select>
                          <div
                          v-if="transactionDetailForm.category === null"
                          class="invalid-feedback-custom"
                          >Kategori harus di isi.</div>
                    </b-form-group>
                  </b-col>
                  <b-col sm="3">
                      <b-form-group label-for="transaction_type" label="Jenis Transaksi">
                          <b-form-input
                              id="total"
                              type="text"
                              v-model="$v.transactionDetailForm.transaction_type.$model"
                              :state="!$v.transactionDetailForm.transaction_type.$invalid"
                              required
                              placeholder="Jenis Transaksi"
                          ></b-form-input>
                          <b-form-invalid-feedback>Jenis Transaksi harus di isi.</b-form-invalid-feedback>
                      </b-form-group>
                  </b-col>
               </b-row>
              </template>
               
               <b-row>
                <b-col lg="9" sm="12">
                    <b-form-group label-for="detail_description" label="Detail Deskripsi">
                        <b-form-textarea
                        id="description"
                        :rows="3"
                        :max-rows="6"
                        v-model="$v.transactionDetailForm.detail_description.$model"
                        :state="!$v.transactionDetailForm.detail_description.$invalid"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>Detail Deskripsi harus di isi.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <div slot="footer" class="text-right">
                <b-button type="button" size="sm" variant="danger" @click="back">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button
                  v-if="transactionDetailForm.status === '1'"
                  type="button"
                  size="sm"
                  variant="primary"
                  @click="editOrder"
                  :disabled="$v.transactionDetailForm.$invalid"
                >
                  <i class="fa fa-save"></i> Save
                </b-button>
              </div>
            </div>
          </b-form>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import loading from "@/templates/Loading.vue";
import "moment/locale/id";
import { VueAutosuggest } from 'vue-autosuggest';
import PaymentSpkb from "./PaymentSpkb";
import custom_validation from "@/templates/_customValidation.js";

export default {
  name: "orderDetail",
  components: { globalTable, ModelSelect, loading, VueAutosuggest, PaymentSpkb },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    },
    valueA: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      loadingAddDetail: false,
      removeButton: true,
      myCustomer: {},
      listBank: [],
      listCategory: [],
      listMutationType: [],
      listHistory: [],
      transactionDetailForm: interfaces.bank_of_transaction,
      fieldRow: [
        'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O'
      ],
      filteredOptions: {
        A: [],
        B: [],
        C: [],
        D: [],
        E: [],
        F: [],
        G: [],
        H: [],
        I: [],
        J: [],
        K: [],
        L: [],
        M: [],
        N: [],
        O: []
      },
      spkb: {
        A: [],
        B: [],
        C: [],
        D: [],
        E: [],
        F: [],
        G: [],
        H: [],
        I: [],
        J: [],
        K: [],
        L: [],
        M: [],
        N: [],
        O: []
      },
      paymentSpkb: {
        spkb_a: null,
        spkb_b: null,
        spkb_c: null,
        spkb_d: null,
        spkb_e: null,
        spkb_f: null,
        spkb_g: null,
        spkb_h: null,
        spkb_i: null,
        spkb_j: null,
        spkb_k: null,
        spkb_l: null,
        spkb_m: null,
        spkb_n: null,
        spkb_o: null
      },
      piutangSpkb: {
        spkb_a: null,
        spkb_b: null,
        spkb_c: null,
        spkb_d: null,
        spkb_e: null,
        spkb_f: null,
        spkb_g: null,
        spkb_h: null,
        spkb_i: null,
        spkb_j: null,
        spkb_k: null,
        spkb_l: null,
        spkb_m: null,
        spkb_n: null,
        spkb_o: null
      },   
      lastPayment: {
        spkb_a: null,
        spkb_b: null,
        spkb_c: null,
        spkb_d: null,
        spkb_e: null,
        spkb_f: null,
        spkb_g: null,
        spkb_h: null,
        spkb_i: null,
        spkb_j: null,
        spkb_k: null,
        spkb_l: null,
        spkb_m: null,
        spkb_n: null,
        spkb_o: null
      },      
      suggestions: [
        {
          data: [],
        },
      ]

    };
  },
  validations() {
      if(this.transactionDetailForm.mutation_type === 'CR') {
        return custom_validation.bankBook.CR;
      } else {
        return custom_validation.bankBook.DB;
      }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function(order_id) {
      this.loading = true;
      this.getDetailData(order_id);
      this.getDropdown();
    },
    getDropdown: function() {
        this.axios
        .get("web/dropdown/bank-book-transaction")
        .then(response => {
            this.listBank = response.data.bank_account;
            this.listCategory = response.data.transaction_category;
            this.listMutationType = response.data.mutation_type;
        })
        .catch(error => {})
        .finally(() => {
            this.loading = false;
        });
    },
    getDetailData: function(id) {
      this.axios
        .get("web/bank_book/detail/" + id )
        .then(response => {
            this.transactionDetailForm = response.data.data;
            this.transactionDetailForm.transaction_date =  new Date(this.transactionDetailForm.transaction_date);
            this.listHistory = response.data.history;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    resetClear: function(flag) {
        this.spkb[flag].value = null;
        this.spkb[flag].text = null;
        this.transactionDetailForm['piutang_spkb_'+flag.toLowerCase()] = null;
        this.setValue(null, flag);
    },
    resetForm: function() {
      for (var a in interfaces.bank_of_transaction) {
        interfaces.bank_of_transaction[a] = null;
      }
      this.transactionDetailForm = interfaces.bank_of_transaction;
    },
    back: function() {
      this.$router.go(-1);
    },
    editOrder: function(evt) {
      evt.preventDefault();
      this.loading = true;
      let piutang_spkb_a = (this.transactionDetailForm.piutang_spkb_a === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_a);
      let piutang_spkb_b = (this.transactionDetailForm.piutang_spkb_b === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_b);
      let piutang_spkb_c = (this.transactionDetailForm.piutang_spkb_c === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_c);
      let piutang_spkb_d = (this.transactionDetailForm.piutang_spkb_d === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_d);
      let piutang_spkb_e = (this.transactionDetailForm.piutang_spkb_e === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_e);
      let piutang_spkb_f = (this.transactionDetailForm.piutang_spkb_f === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_f);
      let piutang_spkb_g = (this.transactionDetailForm.piutang_spkb_g === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_g);
      let piutang_spkb_h = (this.transactionDetailForm.piutang_spkb_h === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_h);
      let piutang_spkb_i = (this.transactionDetailForm.piutang_spkb_i === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_i);
      let piutang_spkb_j = (this.transactionDetailForm.piutang_spkb_j === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_j);
      let piutang_spkb_k = (this.transactionDetailForm.piutang_spkb_k === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_k);
      let piutang_spkb_l = (this.transactionDetailForm.piutang_spkb_l === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_l);
      let piutang_spkb_m = (this.transactionDetailForm.piutang_spkb_m === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_m);
      let piutang_spkb_n = (this.transactionDetailForm.piutang_spkb_n === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_n);
      let piutang_spkb_o = (this.transactionDetailForm.piutang_spkb_o === null) ? 0 : Number(this.transactionDetailForm.piutang_spkb_o);
      let total_payment_piutang = piutang_spkb_a + piutang_spkb_b + piutang_spkb_c + piutang_spkb_d + piutang_spkb_e + piutang_spkb_f + piutang_spkb_g + piutang_spkb_h + piutang_spkb_i + piutang_spkb_j + 
      piutang_spkb_k + piutang_spkb_l + piutang_spkb_m + piutang_spkb_n + piutang_spkb_o;

      if(total_payment_piutang <= parseInt(this.transactionDetailForm.mutation)) {
        this.transactionDetailForm.spkb = this.paymentSpkb;
          if (confirm("Apakah anda ingin mengubah transaksi ini ?")) {
            this.axios
              .put("web/bank_book/update-transaction/", this.transactionDetailForm)
              .then(response => {
                // let _detailData = response.data.data;
                this.showInfoNotification({
                  title: "Update Order",
                  message: response.data.message
                });
              })
              .catch(error => {
                if (error.response.status === 401) {
                  localStorage.clear();
                  this.$router.push({ path: "/login" });
                  this.showErrorNotification({
                    title: "Token Expired",
                    message: "Your session has been expired"
                  });
                } else {
                  this.showErrorNotification({
                    title: "Update Order",
                    message: error.response.data.message
                  });
                }
              })
              .finally(() => {
                let route = this.$route.path.split("/");
                this.init(route[4]);
              });
          }
      } else {
        alert('Total Piutang yang di bayar, lebih dari total mutasi');
        window.location.reload();
      }
    },
    onSelected(item, flag) {
      if (item === "" || item === undefined || item === null) {
        this.spkb[flag].value = null;
        this.spkb[flag].text = null;
        this.setValue(null, flag);
        this.transactionDetailForm['piutang_spkb_'+flag.toLowerCase()] = null;
        return;
      } else {
        this.spkb[flag].value = item.item.value;
        this.spkb[flag].text = item.item.text;
        this.setValue(item.item.value, flag);
        this.findPiutang(item.item.value, flag);
     }
    },
    setValue(value, flag) {
      this.paymentSpkb['spkb_'+flag.toLowerCase()] = value;
      this.piutangSpkb['spkb_'+flag.toLowerCase()] = value;
    },
    focusMe: function(item, flag){
       if (item === "" || item === undefined || item === null) {
        this.spkb[flag].value = null;
        this.spkb[flag].text = null;
        this.setValue(null, flag);
        this.transactionDetailForm['piutang_spkb_'+flag.toLowerCase()] = null;
        return;
      }
    },
    onInputChange(text, flag) {
      if (text === "" || text === undefined || text === null) {
        this.spkb[flag].value = null;
        this.spkb[flag].text = null;
        this.transactionDetailForm['piutang_spkb_'+flag.toLowerCase()] = null;
        this.setValue(null, flag);
        return;
      } else {
        axios
          .post("web/dropdown/find-spkb-piutang/", {'name':text})
          .then((response) => {
            this.dropdown_customer = response.data.data;
            this.suggestions[0].data = this.dropdown_customer;
            const filteredData = this.suggestions[0].data;
            this.filteredOptions[flag] = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => {})
          .finally(() => {});
      }
    },
    findPiutang: function(spkb_number, flag) {
      this.transactionDetailForm['piutang_spkb_'+flag.toLowerCase()] = 0;
      axios
          .post("web/product/find-piutang", {'spkb_number':spkb_number})
          .then((response) => {
             this.piutangSpkb['spkb_'+flag.toLowerCase()] = response.data.data.total_piutang;
             this.lastPayment['spkb_'+flag.toLowerCase()] = response.data.data.last_paid;
             this.transactionDetailForm['piutang_spkb_'+flag.toLowerCase()] = response.data.data.total_piutang;
          })
          .catch((error) => {})
          .finally(() => {});
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    checking: function(paid_amount, piutang, spkb_number, flag) {
        if(spkb_number !== "" && spkb_number !== null) {
          if(Number(paid_amount) > Number(piutang) ) {
              this.transactionDetailForm['piutang_spkb_' + flag] = piutang;
              alert('Total Piutang SPKB '+spkb_number+' Yang di bayarkan tidak boleh melebihi IDR: '+this.formatPrice(piutang));
          }
          if(isNaN(paid_amount)) {
            this.transactionDetailForm['piutang_spkb_' + flag] = null;
            alert('Format Nominal yang anda maksukkan tidak valid');
          }
        } else {
          alert('SPKB '+flag.toUpperCase()+' Harus di pilih dulu');
          this.transactionDetailForm['piutang_spkb_'+flag] = null;
        }
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  }
};
</script>


<style>
.demo { 
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
 
input {
  width: 260px;
  padding: 0.5rem;
}
 
.autosuggest__results > ul {
  width: 100%;
  color: rgba(30, 39, 46,1.0);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 .5rem 0;
}
.autosuggest__results > ul > li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}
.autosuggest__results > ul > li:hover {
  cursor: pointer;
}
 
.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}
 
#autosuggest { width: 100%; display: block;}
.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178,0.2);
}
#autosuggest__input {
      outline: none;
      position: relative;
      display: block;
      font-family: monospace;
      font-size: 20px;
      border: 1px solid #616161;
      padding: 10px;
      width: 100%;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
    }
    
    #autosuggest__input.autosuggest__input-open {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    .autosuggest__results-container {
      position: relative;
      width: 100%;
    }
    
    .autosuggest__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: 10000001;
      width: 100%;
      border: 1px solid #e0e0e0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: white;
      padding: 0px;
      overflow: scroll;
      max-height: 200px;
    }
    
    .autosuggest__results ul {
      list-style: none;
      padding-left: 0;
      margin: 0;
    }
    
    .autosuggest__results .autosuggest__results_item {
      cursor: pointer;
      padding: 15px;
    }
    
    #autosuggest ul:nth-child(1) > .autosuggest__results_title {
      border-top: none;
    }
    
    .autosuggest__results .autosuggest__results_title {
      color: gray;
      font-size: 11px;
      margin-left: 0;
      padding: 15px 13px 5px;
      border-top: 1px solid lightgray;
    }
    
    .autosuggest__results .autosuggest__results_item:active,
    .autosuggest__results .autosuggest__results_item:hover,
    .autosuggest__results .autosuggest__results_item:focus,
    .autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
      background-color: #b6adad;
    }
</style>